'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';


import {
    GET_SCREEN_DATA,
    GET_SCREEN_DATA_RESULT_SELECCIONAR_CUENTA,
    SET_FUNCIONES_DE_USUARIO,
    ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE,
    AGREGAR_QUITAR_CUENTA_VINCULADA,
    CAMBIAR_CUENTA_PRINCIPAL,
    VINCULOSS_BY_NUMERO_CUENTA,
    MOSTRAR_VINCULOS,
    HISTORIAL_MOVIMIENTOS_TARJETA,
    GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID,
    GET_VINCULACIONES,
    ERROR_VINCULACION,
    BORRAR_VINCULO,
    MOSTRAR_OCULTAL_MODAL_VINCULOS,
    CERRAR_MENSAJE_ALERTA_VINCULACIOn
} from '../../Screens/SeleccionCuentas/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    isFetching: false,
    error: false,
    vinculacionError: false,
    loading: false,
    procesoExitoso: false,
    mostrarVinculos: false,
    visibleModalVinculos: false,
    functions: undefined,
    userFeatures: undefined,
    tarjetas: undefined,
    solicitudes: undefined,
    vinculosNroTarjeta: undefined,
    historialTarjetas: [],
    cuentasVinculadas: [],
    cuentasVinculadasOriginales: [],
    cuentaPrincipal: -1,
    solicitudesPlasticos: undefined,
    limites: undefined
}

let result;
export function seleccionCuentas(state = initialState, action) {
    LogHelper.In(seleccionCuentas.name, state, action);

    switch (action.type) {

        case GET_SCREEN_DATA:

            result = {
                ...state,
                loading: true
            };
            break;

        case SET_FUNCIONES_DE_USUARIO:

            result = {
                ...state,
                functions: action.funciones
            };
            break;

        case ALERTA_PROCESO_FINALIZADO_CORRECTAMENTE:

            result = {
                ...state,
                vinculacionError: false,
                procesoExitoso: action.value
            };
            break;

        case CERRAR_MENSAJE_ALERTA_VINCULACIOn:
            result = {
                ...state,
                vinculacionError: false,
            };
            break;

        case CAMBIAR_CUENTA_PRINCIPAL:

            result = { ...state, cuentaPrincipal: action.cuentaCodigo }
            break;

        case AGREGAR_QUITAR_CUENTA_VINCULADA:

            let cuentasVinculadas;
            if (action.cuentaId > 0) {
                cuentasVinculadas = state.cuentasVinculadas;
                let index = cuentasVinculadas.findIndex(x => x.numero == action.cuentaId);

                if (index > -1) {
                    cuentasVinculadas[index].checked = !cuentasVinculadas[index].checked;
                    cuentasVinculadas[index].borrado = !cuentasVinculadas[index].borrado;
                } else {
                    let c = action.cuentas.find(x => x.CodigoCuenta == action.cuentaId);
                    cuentasVinculadas.push({ numero: action.cuentaId, checked: true, tipo: c.NombreProducto, borrado: false });
                }
            } else {
                cuentasVinculadas = [];
                if (action.seleccionoTodo)
                    for (var i = 0; i < action.cuentas.length; i++) {
                        cuentasVinculadas.push({ numero: action.cuentas[i].CodigoCuenta, checked: true, tipo: action.cuentas[i].NombreProducto, borrado: false });
                    }
            }

            result = {
                ...state,
                cuentasVinculadas: cuentasVinculadas
            };
            break;

        case VINCULOSS_BY_NUMERO_CUENTA:
            let v = action.vinculos;
            let cuentasVinculadas3 = state.cuentasVinculadas;

            for (var i = 0; i < v.length; i++) {
                v[i].borrado = false;
            }

            for (var i = 0; i < cuentasVinculadas3.length; i++) {
                let vinculo = v.find(x => x.NumeroCuenta == cuentasVinculadas3[i].numero);
                if (vinculo !== undefined) {
                    cuentasVinculadas3[i].checkOriginal = vinculo.Accion == 'D' ? false : true;
                    cuentasVinculadas3[i].checked = vinculo.Accion == 'D' ? false : true;
                } else {
                    cuentasVinculadas3[i].checkOriginal = true;
                }
            }

            result = {
                ...state,
                vinculosNroTarjeta: v,
                cuentasVinculadas: cuentasVinculadas3
            }
            break;

        case MOSTRAR_VINCULOS:

            result = {
                ...state,
                mostrarVinculos: action.seMuestra
            }
            break;

        case HISTORIAL_MOVIMIENTOS_TARJETA:

            let delivery = action.delivery;
            let solicitud = action.solicitud;
            let historial = [];

            for (var i = 0; i < delivery.length; i++) {
                historial.push(delivery[i]);
            }

            for (var i = 0; i < solicitud.length; i++) {
                historial.push(solicitud[i]);
            }

            historial.sort(function compare(a, b) {
                var fechaA = new Date(a.Fecha);
                var FechaB = new Date(b.Fecha);
                return fechaA - FechaB;
            });

            result = {
                ...state,
                historialTarjetas: historial
            }
            break;

        case GET_SOLICITUDES_PLASTICO_BY_PLASTICO_ID:

            result = {
                ...state,
                solicitudesPlasticos: action.solicitudesPlasticos
            }
            break;

        case ERROR_VINCULACION:

            result = {
                ...state,
                vinculacionError: action.esError
            }
            break;

        case MOSTRAR_OCULTAL_MODAL_VINCULOS:

            result = {
                ...state,
                visibleModalVinculos: action.seMuestra,
                vinculacionError: 0
            }
            break;

        case BORRAR_VINCULO:

            let vinculos = state.vinculosNroTarjeta;
            let cuentasVinculadas2;

            for (var i = 0; i < vinculos.length; i++) {
                if (vinculos[i].NumeroCuenta == action.nroCuenta) {
                    vinculos[i].borrado = true;
                }

            }

            cuentasVinculadas2 = state.cuentasVinculadas;
            let index = cuentasVinculadas2.findIndex(x => x.numero == action.nroCuenta);
            if (index == -1) {
                cuentasVinculadas2.push({ numero: action.nroCuenta, checked: false, tipo: action.NombreProducto, borrado: true, vinculoBorrado: true });
            } else {
                cuentasVinculadas2[index].checked = false;
                cuentasVinculadas2[index].borrado = true;
                cuentasVinculadas2[index].vinculoBorrado = true;
            }

            result = {
                ...state,
                vinculosNroTarjeta: vinculos,
                cuentasVinculadas: cuentasVinculadas2
            }
            break;

        case GET_VINCULACIONES:

            let tarjetas = action.plasticos;
            let cuentas = action.cuentas;
            let tarjetaActual = action.tarjetaActual;

            //Reinicio vinculaciones...
            state.cuentasVinculadas = [];

            //Cargo las vinculaciones entre cuentas...
            for (var m = 0; m < tarjetas.length; m++) {
                if (tarjetas[m].TdPlasticoId == tarjetaActual.id_plastico) {
                    let c = cuentas.find(x => x.CodigoCuenta == tarjetas[m].NumeroCuenta);
                    if (c !== undefined) {
                        if (state.cuentasVinculadas.find(x => x.numero == tarjetas[m].NumeroCuenta) === undefined) {
                            state.cuentasVinculadas.push({ numero: c.CodigoCuenta, checked: true, tipo: c.NombreProducto, borrado: false, FromDB: true });
                        }
                    }
                }
            }

            result = {
                ...state
            }
            break;

        default:
            return state;
    }

    LogHelper.Out(seleccionCuentas.name, result);
    return result;
}

export default seleccionCuentas;
